var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "markets-wrapper",
      class: {
        "live-single-event": _vm.diplayOnPage == "live-single-event",
        coupon: _vm.diplayOnPage == "coupon"
      }
    },
    [
      _vm.markets
        ? _c(
            "div",
            { staticClass: "markets" },
            [
              _vm.isDebug
                ? [
                    _vm._v("\n      MARKETS "),
                    _c("br"),
                    _vm._v(
                      "\n      isBig3Coupon " +
                        _vm._s(_vm.isBig3Coupon) +
                        "\n    "
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.filteredMarkets, function(market, index) {
                return _vm.isOddsBoost &&
                  market.csvpricetypes &&
                  _vm.ksMarketActivePriceTypes(market, _vm.event).includes("XP")
                  ? _c(
                      "div",
                      {
                        key: market.idfomarket,
                        class: [
                          "market",
                          "odds-boost",
                          {
                            suspended:
                              !market.istradable ||
                              _vm.ksIsMarketSuspended(market, _vm.event)
                          }
                        ],
                        attrs: {
                          idfomarket: market.idfomarket,
                          isfrompush: (market.V !== undefined).toString()
                        }
                      },
                      [
                        _c("div", { staticClass: "parent" }, [
                          market && market.selections
                            ? _c(
                                "div",
                                {
                                  staticClass: "selections layout all non-had"
                                },
                                _vm._l(
                                  _vm.vue._.orderBy(market.selections, [
                                    "internalorder",
                                    "price"
                                  ]),
                                  function(selection) {
                                    return selection.idfoselectionsuspensiontype !==
                                      "N/O"
                                      ? _c(
                                          "span",
                                          {
                                            key: selection.idfoselection,
                                            class: [
                                              "selection",
                                              "flex",
                                              {
                                                active:
                                                  _vm.betslipSelections[
                                                    selection.idfoselection
                                                  ]
                                              }
                                            ]
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "odds-boost-selection-name"
                                              },
                                              [_vm._v(_vm._s(selection.name))]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "selection-row" },
                                              [
                                                _c("odds-boost-selection", {
                                                  attrs: {
                                                    estimatedOrCurrentPrice:
                                                      "estimated",
                                                    selection: selection,
                                                    istradable:
                                                      market.istradable &&
                                                      !_vm.ksIsMarketSuspended(
                                                        market,
                                                        _vm.event
                                                      ),
                                                    pricechangehighlight: true
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        return _vm.toggleSelection(
                                                          selection,
                                                          market
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("odds-boost-selection", {
                                                      attrs: {
                                                        estimatedOrCurrentPrice:
                                                          "current",
                                                        selection: selection,
                                                        istradable:
                                                          market.istradable &&
                                                          !_vm.ksIsMarketSuspended(
                                                            market,
                                                            _vm.event
                                                          ),
                                                        pricechangehighlight: true
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  }
                                ),
                                0
                              )
                            : _vm._e()
                        ])
                      ]
                    )
                  : _vm._e()
              })
            ],
            2
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-19399bcc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19399bcc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/bettingoffer/oddsBoost/oddsBoostMarkets.vue
// module id = null
// module chunks = 